import { Box, type SxProps, type Theme } from '@mui/material';
import { useColorMode } from '../app/colorMode';

/** Logo artwork is 1182×200 (wordmark) and 329×587 (the red "E" bars used as the square mark). */
const WORDMARK_RATIO = 1182 / 200;
const MARK_RATIO = 329 / 587;

/**
 * Inditech logo. The grey wordmark has a light twin for dark surfaces; the red mark works on both.
 * `onDark` forces the light twin (e.g. on the dark brand panel) regardless of the colour mode.
 */
export function BrandLogo({ height = 28, mark, onDark, sx }: { height?: number; mark?: boolean; onDark?: boolean; sx?: SxProps<Theme> }) {
  const { mode } = useColorMode();
  const light = onDark || mode === 'dark';
  const src = mark ? '/brand/inditech-mark.svg' : light ? '/brand/inditech-logo-light.png' : '/brand/inditech-logo.png';
  return (
    <Box
      component="img"
      src={src}
      alt="Inditech"
      sx={{ display: 'block', height, width: height * (mark ? MARK_RATIO : WORDMARK_RATIO), flexShrink: 0, ...sx }}
    />
  );
}
